import React, { useState, useEffect, useRef } from 'react';
import ResponseMsg2 from '../../general/ResponseMsg2';
import HeadingArea from '../../general/HeadingArea';
import '../../css/Admin/employee/EmployeeIdCard.css';
import UserLogo from '../../assets/default-img.jpg';
import { FaPrint } from 'react-icons/fa';

const EmployeeIdCard = ({ setLoading, userData }) => {
  const [emp, setEmp] = useState([]);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const printRef = useRef(null);

  const fetchEmp = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-employee');
      if (response.ok) {
        const data = await response.json();
        const filteredData = data.filter(emp => emp.id !== userData.id);
        setEmp(filteredData);
      } else {
        console.error('Failed to fetch employee');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmp();
  }, []);

  // Trigger window.print
  const handlePrint = () => {
    if (!emp.length) {
      setResponse2({ message: 'No Staff ID Cards to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  return (
    <>
      <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Employee" message2="Staff ID Cards" />

          {response2.message && (
            <ResponseMsg2 message={response2.message} status={response2.status} />
          )}

          <div className="text-end d-print-none">
            <button
              className="profile-btn2"
              onClick={handlePrint}
              disabled={!emp.length}
            >
              <FaPrint /> Print
            </button>
          </div>

          <div ref={printRef} className="printable-area">
            <div className="row">
              {emp.map((employee, index) => (
                <div
                  className="col-lg-3 col-md-6 col-12 my-2"
                  key={employee.id || index}
                >
                  <div className="staff-icard">
                    <p className="staff-icard-heading">K C Public School</p>

                    <img
                      src={
                        employee.profile_pic && employee.profile_pic.trim() !== ''
                          ? `https://api.kcian.in/inUploads/${employee.profile_pic}`
                          : UserLogo
                      }
                      className="icard-img"
                      alt={employee.name}
                    />

                    <p className="bg-light para-text mt-3 py-2 fw-semibold">
                      {employee.name}
                      <br />
                      {employee.designation}
                    </p>
                    <p>
                      Reg No: {employee.user_id}
                      <br />
                      Mobile: {employee.mobile}
                      <br />
                      Blood Grp: {employee.blood_grp || '-'}
                      <br />
                      Address: {employee.address || '-'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Add print-specific styles */}
      <style>{`
@media print {
  body * {
    visibility: hidden;
  }
  .printable-area, .printable-area * {
    visibility: visible;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .staff-icard {
    page-break-inside: avoid;
    -webkit-print-color-adjust: exact;
  }
  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  .printable-area .col-lg-3{ 
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

      `}</style>
    </>
  );
};

export default EmployeeIdCard;
